// The part of the menu for rooms. It shows only in a room: it names the code,
// copies the link, and leaves. Leave asks once while a match is in play,
// because it gives the match up. A room starts in the caster select, with
// Invite or Join. The menu had a button for it until 2026-10-14. Garrett:
// "remove the play a friend from the menu we'll keep it in the new game flow".
// The words are plain placeholders.

import { el } from '../lib/dom';
import { gameStore } from '../state/game';
import { leaveRoom } from '../state/room';
import { roomStore } from '../state/roomStore';
import { createAskingButton } from './AskingButton';

const COPY_LABEL = 'Copy link';
const COPIED_LABEL = 'Copied';
const LEAVE_LABEL = 'Leave room';
const COPIED_MS = 1500;

export const createRoomMenu = (): HTMLElement => {
  const code = el('span', { className: 'room-lobby__code room-menu__code' });
  const copyButton = el('button', {
    className: 'button button--pass-through',
    type: 'button',
    textContent: COPY_LABEL,
    onclick: () => {
      const room = roomStore.get();
      if (!room) return;
      void navigator.clipboard?.writeText(`${window.location.origin}/${room.code}`).then(() => {
        copyButton.textContent = COPIED_LABEL;
        window.setTimeout(() => {
          copyButton.textContent = COPY_LABEL;
        }, COPIED_MS);
      });
    },
  });
  const leaveButton = createAskingButton({
    label: LEAVE_LABEL,
    mustAsk: () => {
      const { ply, phase } = gameStore.get();
      return roomStore.get()?.view?.phase === 'playing' && ply > 0 && phase !== 'over';
    },
    onConfirm: leaveRoom,
  });
  const root = el('div', { className: 'room-menu' }, [
    el('div', { className: 'room-menu__room' }, [
      el('span', { className: 'setting__label', textContent: 'Room' }),
      code,
      copyButton,
      leaveButton,
    ]),
  ]);

  const draw = (): void => {
    const room = roomStore.get();
    root.hidden = room === null;
    code.textContent = room?.code ?? '';
  };
  draw();
  roomStore.subscribe(draw);
  return root;
};
